import script from "./pc-audit-form.vue?vue&type=script&lang=ts&setup=true"
export * from "./pc-audit-form.vue?vue&type=script&lang=ts&setup=true"

import "./pc-audit-form.vue?vue&type=style&index=0&id=5ecaa24e&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ecaa24e"]])

export default __exports__